// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","option":"packOption_option__NlRm9","selected_option":"packOption_selected_option__II_lw","itemPrice":"packOption_itemPrice__K16bb"};